import { useQuery } from '@hooks/reactQuery';

import { getPortalTimelineStatuses } from '@api/portalTimeline';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_TIMELINE_STATUSES } from '@constants/queryKeys';

interface IUseQueryPortalTimelineStatusesReturned {
	portalTimelineStatuses: Array<TSelectOption>;
	isLoadingPortalTimelineStatuses: boolean;
}

export const useQueryPortalTimelineStatuses = (projectId?: string): IUseQueryPortalTimelineStatusesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TIMELINE_STATUSES, projectId],
		queryFn: extractQueryParams(getPortalTimelineStatuses),
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalTimelineStatuses: data || [],
		isLoadingPortalTimelineStatuses: isLoading || isFetching,
	};
};
